export default {
  CREATE_COMPLIANCE_ISSUE_REQUEST: "[complianceIssues] CREATE Compliance Issue",
  UPDATE_COMPLIANCE_ISSUE_REQUEST: "[complianceIssues] UPDATE Compliance Issue",
  DELETE_COMPLIANCE_ISSUE_REQUEST: "[complianceIssues] DELETE Compliance Issue",
  GET_COMPLIANCE_ISSUES_REQUEST: "[complianceIssues] GET Compliance Issues",
  SET_COMPLIANCE_ISSUES: "[complianceIssues] SET Compliance Issues",
  // INSERTION_PT (for script, do not remove)
};
